import axiosInstance from "../utils/axios"

export const accessService = {
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/access/paginate', {
      params,
    })
    return response.data
  },
  store: async (data) => {
    const response = await axiosInstance.post('/access', data)
    return response.data
  },
  update: async (id, data) => {
    const response = await axiosInstance.put(`/access/${id}`, data);
    return response.data;
  },  
  delete: async (id) => {
    const response = await axiosInstance.delete(`/access/${id}`)
    return response.data
  },
}
